module.exports = "<!-- <p-growl [(value)]=\"globalService.messages\"></p-growl> -->\r\n\r\n<!--<a style=\"cursor: pointer\"  class=\"\">Sign out</a>-->\r\n<!--/Login Area Dropdown-->\r\n<div class=\"page-body\">\r\n  <div class=\"row survey-details\">\r\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 bgWhite\">\r\n      <h4 class=\"m-b-20\">Force Logout Please click on Sign Out</h4>\r\n      <button class=\"btn bgBlue m-b-20\" (click)=\"logOut();\" type=\"button\">Sign out</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout.component.html
// module id = ./src/app/logout.component.html
// module chunks = main